import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetCategoriesResponse } from './types';

export const getCategories = async (): Promise<GetCategoriesResponse> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/categories`;

	const response: GetCategoriesResponse = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching categories:', error);
			return [];
		});

	return response;
};
